<template>
	<div id="media" :style="{ 'background-image': 'url(' + custombackground.url + ')' }">
		<!-- cd-main-content -->
		<main class="mediaNavs">
			<div class="vennWrapper">
				<div class="circleWrapper"> 
					<div class="circleContent left"
							@click="animate('photo')">
						<h3>Photos</h3>
					</div>
				</div>
			</div>

			<div class="vennWrapper">
				<div class="circleWrapper">
					<div class="circleContent middle"
							@click="animate('music')">
						<h3>Music</h3>
					</div>
				</div>
			</div>

			<div class="vennWrapper">
				<div class="circleWrapper">
					<div class="circleContent right"
							@click="animate('video')">
						<h3>Videos</h3>
					</div>
				</div>
			</div>
		</main>

		<!-- cd-modal -->
		<div 	class="mediaDisplays" 
				ref="displayLayer">
			<div class="content">
				<Photos v-if="selected==='photo'" :posts="posts"/>

				<Music v-if="selected==='music'"/>

				<Videos v-if="selected==='video'" :videos="posts"/>
			</div>

			<a 	href="#0" 
				class="closeBtn" 
				@click="close()">Close</a>
		</div>

		<!-- cd-transition-layer -->
		<div 	class="mediaTransition"
				ref="transitionLayer"
				v-on:animationend="closeAnimationEnd()">
			<div 	class="bg-layer"
					ref="transitionBg"
					:style="{
						'width': transitionEl.width,
						'height' : transitionEl.height
					}"> 
			</div>
		</div>
	</div>
</template>

<script>

import Photos from '../components/media/Photos';
import Music from '../components/media/Music';
import Videos from '../components/media/Videos';

export default{
	name:"Media",
	components:{Photos, Music, Videos},
	data(){
		return{
			delay: 900,
			frameProportion: 1.78,
			frames: 20,
			transitioning: null,
			selected: null,
			transitionEl : {
				width : 0,
				height : 0
			}
		}
	},
	mounted(){
		this.setLayerDimensions();
	},
	methods:{
		animate : function(side){
			let cls = ['visible', 'opening'];
			
			this.selected = side;
			this.$refs.transitionLayer.classList.add(...cls);

			setTimeout(()=>{
				this.$refs.displayLayer.classList.add('visible');
			}, this.delay);
		},
		close : function(){
			this.selected = null;

			this.$refs.displayLayer.classList.remove('visible');
			this.$refs.transitionLayer.classList.add('closing');
		},
		closeAnimationEnd : function(){
			var cls = (this.selected) ? ['opening'] : ['closing', 'opening', 'visible'];
			this.$refs.transitionLayer.classList.remove(...cls);
		},
		setLayerDimensions: function(){
			// let containerWidth = this.$refs.dates.offsetWidth;
			let windowWidth = window.innerWidth,
				windowHeight = window.innerHeight,
				layerHeight, layerWidth;

			if(windowWidth/windowHeight > this.frameProportion){
				layerWidth = windowWidth;
				layerHeight = layerWidth/this.frameProportion;
			}
			else{
				layerHeight = windowHeight * 1.2;
				layerWidth = layerHeight * this.frameProportion;
			}

			this.transitionEl.width = layerWidth*this.frames+'px';
			this.transitionEl.height = layerHeight+'px';
		}
	},
	props: [ 'posts', 'media', 'custombackground' ]
}
</script>

<style scoped lang="scss">
	@import '~@/assets/scss/_variables.scss';

	@import '~@/assets/scss/_mixins.scss';

	@import '~@/assets/scss/_layout.scss';

	$duration: .9s;
// Diamond
	$bgEnd : -97.5%;
	$bgStart : -2.5%;
	$steps: 19;
	$bgWidth: 2000%;
// Cartoon
	// $bgEnd : -98%;
	// $bgStart : -2%;
	// $steps: 24;
	// $bgWidth: 2500%;

	h1{
		font-family: 'Montserrat', 'san-serif';
		font-size: 3em;
		top: calc(100% - 12px);
		// transform: translateY(250%);
	}

	h3{
		font-family: 'Raleway', 'san-serif';
		font-size: 2em;
		position: relative;
		top: calc(100% - 75px);
		// transform: translateY(250%);
	}

	#media{
		height: 90vh;
		width: 100vw;
		position: relative;
		background: $darkPurple;
		// background: linear-gradient(180deg, $beigeMint 0%, $lightPurple 100%);	
		background-repeat: no-repeat;
 	   	background-size: cover;
    	// background-position: center;
    	background-position: 50% 50%;

		.mediaNavs{
			display: inline-flex;
			height: 100%;
			width: 100%;

			.vennWrapper{
				display: table;
				height: 100%;
				margin: 0 auto;

				.circleWrapper{
					display: table-cell;
					text-align: center;
					vertical-align: middle;

					.circleContent{
						transition: all .2s ease-in-out;
						height: 135px;
						width: 135px;
						border-radius: 200px;
						border: 10px solid $lightPurple;
						background: $nearWhite;


						&.left,
						&.middle,
						&.right {
							border: 10px solid $darkPurple;
							background: $nearWhite;

							&:hover{
								// height: 100%;
								// border-radius: 0;
								transform: scale(1.5);
								background: $lightPurple;
								border: 10px solid $lightPurple;
								color: white;
							}
						}
					}
				}
			}
		}
	}

	//cd-main-content
	main{
		position: relative;
		z-index:1;
		width: 100%;
		height: 100%;
		display: table;
	}

	//cd-modal
	.mediaDisplays{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 3;
		height: 100%;
		width: 100%;
		overflow: hidden;
		opacity: 0;
		visibility: hidden;
		transition: opacity .3s 0s, visibility 0s .3s;

		.content{
			height: 100%;
			overflow-y: hidden;
			padding: 1.5em;
		}

		.closeBtn{
			/* 'X' icon */
			position: absolute;
			z-index: 3;
			top: 20px;
			right: 5%;
			height: 45px;
			width: 45px;
			border-radius: 50%;

			overflow: hidden;
			white-space: nowrap;
			text-indent: 100%;
			color: transparent;
			
			// visibility: hidden;
			opacity: 0;
			transform: scale(0);
			transition: transform .3s 0s, visibility 0s .3s, opacity .3s 0s;

			background: shade($beigeMint, 15%);

			&:hover{
				background: shade($beigeMint, 30%);
			}

			&::before, &::after {
				content: '';
				background: $nearWhite;
				display: inline-block;
				position: absolute;
				height: 2px;
				width: 20px;
				top: calc(50% - 1px);
				left: calc(50% - 10px);
			}

			&::before {
				transform: rotate(45deg);
			}

			&::after {
				transform: rotate(-45deg);
			}		
		}

		&.visible {
			opacity: 1;
			visibility: visible;
			transition: opacity .7s, visibility 0s;

			.content {
				/* this fixes the buggy scrolling on webkit browsers - mobile devices only - when overflow property is applied */
				-webkit-overflow-scrolling: touch;
			}

			.closeBtn {
				visibility: visible;
				opacity: 1;
				transition: transform .3s 0s, visibility 0s 0s, opacity .3s 0s;
				transform: scale(1);
			}
		}

		@include MQ(L) {
			.content {
				padding: 1.5em;
			}

			.closeBtn { 
				height: 60px;
				width: 60px;

				&::before, &::after {
					height: 2px;
					width: 26px;
					top: calc(50% - 1px);
					left: calc(50% - 13px);
				}
			}
		}	
	}

	//cd-transtition-layer
	.mediaTransition{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		height: 100%;
		width: 100%;
		opacity: 0;
		visibility: hidden;
		overflow: hidden;

		.bg-layer {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translateY(-50%) translateX($bgStart);
			/* its dimentions will be overwritten using jQuery to proportionally fit the viewport */
			height: 100%;
			/* sprite composed of 38 frames */ 
			width: $bgWidth;
			background-image: url('~@/assets/img/media/diamond.png');
			background-size: 100% 100%;
			background-repeat: no-repeat;
			background-position: 0 0;
		}

		&.visible {
			opacity: 1;
			visibility: visible;

			.bg-layer {
				transform: translateY(-50%) translateX($bgEnd);
			}
		}

		&.opening .bg-layer,
		&.closing .bg-layer {
			animation-duration: $duration;
			animation-fill-mode: forwards;
		}
		
		&.opening .bg-layer{
			animation: shift $duration steps($steps) forwards;
		}
		
		&.closing .bg-layer {
			animation: shift $duration steps($steps) forwards reverse;
		}

		&.no-cssanimations {
			display: none;
		}		
	}

	@media screen and (max-width: $largeLaptopWidth){
	}

	@media screen and (max-width: $tabletWidth){
	}

	@media screen and (max-width: $largeMobile){
		#media{
			height: 100vh;
			background: none !important;

			.mediaNavs {
				display: grid;
    			grid-template-rows: 33.33% 33.33% 33.33%;

				.vennWrapper{
					.circleWrapper{
						display: block;
						height: 33.33vh;

						.circleContent{
							border: 0;
							border-radius: 0;
							height: 100%;
							width: 100vw;


							h3{
								top: calc(50% - .75em);
								color: white;
							}

							&.left{
							}

							&.middle{
							}

							&.right{
							}

							&.left,
							&.middle,
							&.right{
								background: $beigePink;

								&:hover{
									transform: none;
									border: 0;
									background: $nearWhite;
									h3{
										color: black;
									}
								}							
							}
						}
					}
				} 
			}
		}

		.mediaDisplays{
			background: $beigePink;
			.content{
				padding: 3em 1em;
			}
		}

		.mediaTransition{

			.bg-layer{
				// display: none;

				&.opening .bg-layer{
					// animation: none;
				}

				&.closing .bg-layer {
					// animation: none;
				}	
			}
		}
	}

	@keyframes shift {
		0% {
			transform: translateY(-50%) translateX($bgStart);
		}
		100% {
			transform: translateY(-50%) translateX($bgEnd);
		}
	}

</style>